import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function settingReducer(state = initialState.settings, action) {
	switch (action.type) {
		case types.READ_SETTINGS_SUCCESS:
			return Object.assign([], action.data);

		case types.DISABLE_PAGE:
			return Object.assign([], state, { disabled: action.disablePage });

		default:
			return state;
	}
}
